<template>
  <v-row>

    <v-col cols="12" class="px-0">
      <v-data-table
          dark
          class="background-table"
          align="center"
          :headers="visibleHeaders"
          :items="items.data"
          :items-per-page="items.pagination ? items.pagination.per_page : 100"
          disable-sort
          hide-default-footer>

        <template v-slot:[`item.image_url`]="{ item }">
          <img :src="item.image_url" class="table-thumb" alt="" loading="lazy">
        </template>

        <template v-slot:[`item.invoice_url`]="{ item }">
          <v-btn v-if="item.invoice_url" block color="info" @click="$emit('downloadInvoice', item)">
            دانلود
          </v-btn>
          <div v-else>-</div>
        </template>

        <template v-slot:[`item.parent`]="{ item }">
          <div v-if="item.parent_category">
            {{ item.parent_category.id }} | {{ item.parent_category.fa_name }}
          </div>
        </template>

        <template v-slot:[`item.customer`]="{ item }">
          <div v-if="item.customer">
            {{ 'شناسه: ' + item.customer.id }} <br>
            {{ item.customer.name }} <br>
            {{ item.customer.phone_number }}
          </div>
        </template>

        <template v-slot:[`item.category`]="{ item }">
          <div v-if="item.category">
            {{ item.category.id }} | {{ item.category.fa_name }}
          </div>
        </template>

        <template v-slot:[`item.details`]="{ item }">
          <v-btn fab x-small icon color="warning" @click="$emit('showDetails', item)">
            <v-icon>mdi-eye</v-icon>
          </v-btn>
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <v-chip small :class="['status-chip', item.status ? 'status-chip--on' : 'status-chip--off']"
                  @click="$emit('statusChanged', item)">
            <v-icon left x-small>{{ item.status ? 'mdi-check-circle' : 'mdi-close-circle' }}</v-icon>
            {{ item.status ? 'فعال' : 'غیرفعال' }}
          </v-chip>
        </template>

        <template v-slot:[`item.status_name`]="{ item }">
          <v-menu left bottom offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" rounded x-small :color="getColorBaseOnStatus(item)">
                {{ item.status_name }}
              </v-btn>
            </template>

            <v-list width="150px" color="#393E46">
              <v-list-item class="pointer">
                <v-list-item-title @click="$emit('statusChanged', item, 0)">
                  <span class="centered-text-in-list">در حال بررسی</span>
                </v-list-item-title>
              </v-list-item>

              <v-list-item class="pointer">
                <v-list-item-title @click="$emit('statusChanged', item, 1)">
                  <span class="centered-text-in-list">ارسال صورتحساب</span>
                </v-list-item-title>
              </v-list-item>

              <v-list-item class="pointer">
                <v-list-item-title @click="$emit('statusChanged', item, 2)">
                  <span class="centered-text-in-list">لغو شده</span>
                </v-list-item-title>
              </v-list-item>

              <v-list-item class="pointer">
                <v-list-item-title @click="$emit('statusChanged', item, 3)">
                  <span class="centered-text-in-list">پایان یافته</span>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>

        <template v-slot:[`item.persian_created_at`]="{ item }">
          <div class="dates">{{ item.persian_created_at }}</div>
        </template>

        <template v-slot:[`item.persian_updated_at`]="{ item }">
          <div class="dates">{{ item.persian_updated_at }}</div>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <div class="row-actions">
            <v-tooltip bottom v-for="(action, index) in actions" :key="index">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    icon
                    small
                    :class="['row-action', action.delete_confirm ? 'row-action--danger' : '']"
                    :aria-label="actionLabel(action)"
                    v-bind="attrs"
                    v-on="on"
                    @click="doAction(action, item)"
                >
                  <v-icon small>{{ action.icon }}</v-icon>
                </v-btn>
              </template>
              <span>{{ actionLabel(action) }}</span>
            </v-tooltip>
          </div>
        </template>

        <template v-slot:[`item.searchable`]="{ item }">
          {{ item.searchable ? "هست" : "نیست"}}
        </template>

      </v-data-table>
    </v-col>

    <v-col cols="12" class="justify-center d-flex" v-if="items.pagination">
      <v-pagination
          class="float-right"
          color="#00ADB5"
          v-model="currentPage"
          :length="items.pagination.last_page"
          :total-visible="$store.state.windowIsSmallerThanMobile ? 5 : 9"
          circle
      ></v-pagination>
    </v-col>

    <v-dialog v-model="dialog" width="480px">
      <v-card color="#393E46">
        <v-card-title class="d-flex align-center">
          <v-icon color="#fb4e4e" class="ml-2">mdi-alert-circle</v-icon>
          حذف
        </v-card-title>
        <v-card-text>{{ dialogTitle }}</v-card-text>
        <v-card-actions class="px-6 pb-6">
          <div class="form-actions" style="width: 100%">
            <v-btn class="btn-secondary" outlined @click="resetAction()">
              انصراف
            </v-btn>
            <v-btn class="btn-danger" outlined @click="dialogConfirmed = true; doAction()">
              <v-icon left>mdi-delete</v-icon>
              بله، حذف شود
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
export default {
  name: "TableWithPagination",

  props: ["headers", "items", "actions", "defaultPage"],

  data() {
    return {
      currentPage: 1,

      dialog: false,
      dialogTitle: null,
      dialogConfirmed: false,

      selectedAction: null,
      selectedItem: null,
    }
  },

  beforeMount() {
    this.currentPage = this.defaultPage
  },

  computed: {
    // English columns follow the same "show English fields" switch as the forms.
    visibleHeaders() {
      if (this.$store.state.showEnglishFields) return this.headers
      return this.headers.filter((header) => !String(header.value).startsWith('en_'))
    },
  },

  methods: {
    actionLabel(action) {
      if (action.tooltip) return action.tooltip
      if (action.delete_confirm) return 'حذف'
      if (action.icon === 'mdi-pencil') return 'ویرایش'
      return ''
    },

    doAction(action = null, item = null) {
      this.selectedAction = action ? action : this.selectedAction
      this.selectedItem = item ? item : this.selectedItem

      if (this.selectedAction.delete_confirm && !this.dialogConfirmed) {
        this.dialog = true
        this.dialogTitle = 'آیا از حذف ' + (this.selectedItem.fa_name ?? this.selectedItem.id) + ' مطمئن هستید؟'
        return
      }
      if (this.selectedAction.route_name) {
        let $route = {
          name: this.selectedAction.route_name,
          params: {}
        }
        if (this.selectedAction.route_param) {
          $route.params[this.selectedAction.route_param] = this.selectedItem[this.selectedAction.route_param]
        }

        this.$router.push($route)
      } else if (this.selectedAction.identifier === 'object') {
        this.$emit(this.selectedAction.emit, this.selectedItem)
      } else {
        this.$emit(this.selectedAction.emit, this.selectedItem[this.selectedAction.identifier])
      }

      this.resetAction()
    },

    resetAction() {
      this.selectedItem = null
      this.selectedAction = null
      this.dialog = false
      this.dialogTitle = null
      this.dialogConfirmed = false
    },

    getColorBaseOnStatus(item) {
      switch (item.status) {
        case 0:
          return 'warning'
        case 1:
          return 'info'
        case 2:
          return 'error'
        case 3:
          return 'success'
      }
    }
  },

  watch: {
    currentPage: function (val) {
      if (val === this.defaultPage) {
        return
      }

      this.$router.push({
        path: this.$route.path,
        query: {...this.$route.query, page: val}
      });
      this.$emit("fetchPage", val)
    },
  }
}
</script>

<style scoped>
.background-table {
  background-color: #393E46;
}

.table-thumb {
  display: block;
  width: 56px;
  height: 56px;
  margin: 6px auto;
  border-radius: var(--radius-sm);
  background: #fff;
  object-fit: contain;
}

.row-actions {
  display: inline-flex;
  gap: 6px;
  white-space: nowrap;
}

.row-action {
  border: 1px solid rgba(0, 173, 181, 0.45);
}

.row-action >>> .v-icon {
  color: #00ADB5 !important;
}

.row-action--danger {
  border-color: rgba(251, 78, 78, 0.5);
}

.row-action--danger >>> .v-icon {
  color: #fb4e4e !important;
}

.status-chip {
  cursor: pointer;
}

.status-chip--on {
  background: rgba(76, 175, 80, 0.18) !important;
  color: #81c784 !important;
}

.status-chip--off {
  background: rgba(251, 78, 78, 0.16) !important;
  color: #fb4e4e !important;
}

.status-chip >>> .v-chip__content,
.status-chip >>> .v-icon {
  color: inherit !important;
}

.pointer {
  cursor: pointer;
}
</style>